/* src/app/core/science/science.component.scss */
.carousel {
  top: 15%;
  position: absolute;
  width: 100%;
  min-height: 85%;
}
.carousel-item .text-content {
  min-width: 660px;
  min-height: auto;
}
.carousel-item .text-content h1 {
  font-family: "Campton-Bold";
  font-size: 42px;
  font-weight: bold;
  line-height: 1.19;
  text-align: left;
  color: #ffffff;
}
.carousel-item .text-content h2 {
  font-family: "Campton-Bold";
  font-size: 36px;
  font-weight: bold;
  line-height: 1.17;
  text-align: left;
  color: #ffffff;
  margin-bottom: 8px;
}
.carousel-item .text-content p {
  font-family: "Campton-Light";
  font-size: 18px;
  font-weight: 300;
  line-height: 1.56;
  letter-spacing: 0.5px;
  text-align: left;
  color: #ffffff;
  margin-bottom: 24px;
}
.carousel-item .text-content.references p {
  font-family: "Campton-Light";
  font-size: 14px;
  font-weight: 300;
  line-height: 1.5;
  text-align: left;
  color: #ffffff;
  word-break: break-all;
}
/*# sourceMappingURL=science.component.css.map */
